export const constant = {
  mainTitle: '品位商城',
  copyright: '©20016-2021 PinWei100.com 版权所有 未授权不得商用',
  tel: '400-800-8888', // 官网联系电话
  URL: 'http://b2b2c.pinwei100.com/#/', // PC端最终地址
  agentURL: 'http://agent.pinwei100.com/', // 商户中心地址
  s_url: 'http://b2b2c.pinwei100.com/' // 店铺首页导航地址
}

export const Status = {
  '-1': '取消订单',
  '0': '立即付款',
  '1': '已支付',
  '2': '发货中',
  '3': '已发货',
  '4': '已收货',
  '5': '退货审核中',
  '6': '审核失败',
  '7': '审核成功',
  '8': '退款中',
  '9': '退款成功'
}
